// src/components/tileTransformer.js

class TileTransformer {
  constructor() {
    // Initialize any required properties here
    this.cache = {};
  }

  /**
   * Transforms the original tile URL to a recolored version.
   * @param {string} url - Original tile URL.
   * @returns {string} - Transformed tile URL.
   */
  getOrCreateRecoloredUrl(url) {
    if (this.cache[url]) {
      return this.cache[url];
    }

    // Implement your logic to transform the URL
    // For demonstration, let's append a query parameter
    const urlObj = new URL(url);
    urlObj.searchParams.append("recolor", "true");
    const newUrl = urlObj.toString();

    // Cache the transformed URL
    this.cache[url] = newUrl;
    return newUrl;
  }
}

export default TileTransformer;
